import React from 'react'

const SkeletonCard = () => {
    return (
        <div className="card">
            <div className="card-img-top placeholder-glow" style={{ height: '200px' }}>
                <span className="placeholder col-12 h-100"></span>
            </div>
            <div className="card-body">
                <h5 className="card-title placeholder-glow">
                    <span className="placeholder col-6"></span>
                </h5>
                <p className="card-text placeholder-glow">
                    <span className="placeholder col-7"></span>
                    <span className="placeholder col-4"></span>
                </p>
                <a href="#" tabIndex="-1" className="btn disabled placeholder col-6"></a>
            </div>
        </div>
    )
}

export default SkeletonCard